import { add, isBefore, differenceInYears, startOfYear } from 'date-fns'
import { getBirthDate } from 'lib/birthNumber'

// Calculate current age
// Note: We consider everyone to be born 1. jan, to support FHIs definition of age groups
export function calculateCurrentAge(nationalId: string) {
  const birthDate = getBirthDate(nationalId)
  if (birthDate == null) {
    return null
  }
  const currentAge = differenceInYears(new Date(), startOfYear(new Date(birthDate)))

  return currentAge
}

type Vaccination = {
  completed_at: string
  national_id: string
}

// Helper to figure out how many doses a person has, and the correct delay between them
export default function calculateAllowDose3BookingFromDate(vaccinations: Vaccination[]) {
  // We only care about completed doses
  const completedVaccinations = vaccinations
    .filter((vaccination) => vaccination?.completed_at)
    .sort((a, b) => (a.completed_at < b.completed_at ? 1 : -1)) // Reverse order, newest first

  // Currently this is only used for dose 3
  if (completedVaccinations?.length !== 2) {
    return null
  }

  // Get national id from one of the vaccinations
  const nationalId = vaccinations.find((vaccination) => vaccination.national_id)?.national_id
  if (nationalId == null) {
    return null
  }

  // Delay is currently 20 weeks for all age groups 18+
  const allowDose3BookingFromDate = add(new Date(completedVaccinations[0].completed_at), {
    weeks: 20,
  })

  // If allowed start date is in the past, skip it, they don't need a delay
  if (isBefore(new Date(allowDose3BookingFromDate), new Date())) {
    return null
  }

  return allowDose3BookingFromDate
}
